import DeviationDuperbrowseContext from '@wix/da-shared-react/pkg/Duperbrowse/DeviationDuperbrowseContext';
import DuperbrowseContextContainer from './DuperbrowseContext.container';

export default DuperbrowseContextContainer(DeviationDuperbrowseContext);
